import { defineSlotRecipe } from '@chakra-ui/react';

export const syntaxHighlighterRecipe = defineSlotRecipe({
  className: 'syntax-highlighter',
  slots: ['container'],
  base: {
    container: {
      h: '100%',
      pos: 'relative',
      overflow: 'auto',
      '& > pre': {
        h: '100%',
        w: '100%',
        display: {
          base: 'inline-flex',
          sm: 'flex',
        },
        _before: {
          top: '4px',
          left: '8px',
          pos: 'absolute',
          fontSize: '0.8rem',
        },
      },
    },
  },
});

export const descriptionRecipe = defineSlotRecipe({
  className: 'description',
  slots: [
    'filename',
    'markdown',
    'container',
    'markdownDesc',
    'filenameContainer',
    'markdownContainer',
  ],
  base: {
    container: {
      '& .desc-code': {
        border: '1px solid',
        borderColor: 'gray.400',
      },
      '& .desc:first-child > .desc-code': {
        '& > pre > div > pre': {
          borderTopRadius: 'md !important',
        },
      },
      '& .desc:last-child > .desc-code': {
        borderTop: 0,
        borderBottomRadius: 'md !important',
        '& > pre > div > pre': {
          borderBottomRadius: 'md !important',
        },
      },
    },
    filenameContainer: {
      p: 2,
      borderBottom: 0,
      borderTopRadius: 'md',
      border: '1px solid {colors.gray.400}',
    },
    filename: {
      color: 'white',
    },
    markdownContainer: {
      alignItems: 'center',
      _hover: {
        borderRadius: 'md',
        outline: '2px solid',
        outlineOffset: '-1px',
        outlineColor: 'blue.500',
      },
    },
    markdown: {
      h: '100%',
      '& > pre': {
        h: '100%',
        pos: 'unset',
        '& > div': {
          pos: 'unset',
          '& > pre': {
            m: '0 !important',
            pos: 'unset !important',
            borderRadius: '0 !important',
          },
        },
      },
    },
    markdownDesc: {
      px: '1rem',
      py: '2rem',
      color: 'white',
      whiteSpace: 'normal',
      fontFamily:
        'monoId, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
  },
  variants: {
    variant: {
      file: {
        container: {
          '& .desc:first-child > .desc-code': {
            borderTopRadius: 'unset',
          },
        },
      },
      normal: {
        container: {
          '& .desc:first-child > .desc-code': {
            borderTopRadius: 'md',
          },
        },
      },
    },
  },
});
